/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// action
import { requestRatingWidget } from 'state/actions/ratingsState/ratingsStatus';
// component
import RequestRatingWidget from 'pages/dashboard/ratings/requestratingwidget/requestratingwidget';
import {displayModal} from "@insticator/insticator-ui";



/* ========== ~~~~~~~~~~ REQUEST RATINGS WIDGET : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ ratingsState, sessionStatus }) => ({
    status: ratingsState.ratingsStatus.requestStatus,
    emailSentTo: sessionStatus.userEmail,
    requestPending: ratingsState.ratingsStatus.requestPending,
    approving: ratingsState.ratingsStatus.approving,
    requestSent: ratingsState.ratingsStatus.requestSent,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked,
});

const mapDispatchToProps = dispatch => ({
    requestRatingWidget: (accountUUID) => dispatch(requestRatingWidget(accountUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestRatingWidget));
